import { render } from "./reminderTips.vue?vue&type=template&id=79c6acc6&scoped=true"
const script = {}

import "./reminderTips.vue?vue&type=style&index=0&id=79c6acc6&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c6acc6"]])

export default __exports__